import Swiper from 'swiper'
import { Navigation, Pagination } from 'swiper/modules'

import 'swiper/css'
import 'swiper/css/navigation'
import 'swiper/css/pagination'

import { HeaderTheme, setHeaderDisplay, setHeaderTheme } from '@app-components'

{
    const heroContainer = document.getElementById('end-market-hero')!

    const observer = new IntersectionObserver(([element]) => {
        if (element.intersectionRatio >= 0.85) {
            setHeaderDisplay('none')
            setHeaderTheme(HeaderTheme.TRANSPARENT_WHITE)
        } else {
            setHeaderDisplay('brand-logo')
            setHeaderTheme(HeaderTheme.WHITE)
        }
    }, { threshold: [1, 0.85, 0.1, 0] })

    observer.observe(heroContainer)
}

new Swiper('.strategy--swiper.swiper', {
    modules: [Navigation, Pagination],
    slidesPerView: 1,
    centeredSlides: true,
    loop: true,
    speed: 500,
    loopAdditionalSlides: 2,
    navigation: {
        nextEl: '.swiper-button-next',
        prevEl: '.swiper-button-prev',
    },
    pagination: {
        el: '.strategy .swiper-pagination',
        type: 'bullets',
        clickable: true,
        renderBullet: (index: number, className: string) => `<span class="${className}"></span>`,
    },
})
